import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')],
})
export class HomeComponent implements OnInit {
  public testimonial1: any = {};
  public testimonial2: any = {};

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.http.get('./testimonials.json').subscribe(data => {
      this.testimonial1 = data[0];
      this.testimonial2 = data[1];
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/home.component.ts